module.exports = __webpack_public_path__ + "img/selectTag.ee628887.svg";